module.exports = __webpack_public_path__ + "static/media/Services - Clinical Tials Icon.a0aabb95.svg";